import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
} from "@mui/material";
import logoALLIED from "../../logo/Alliadnew.png";
import AlliadLogo from "../../commonlogo/logo";
import SendOtp from "./sendOtp";
import VerifyOtp from "./verifyOtp";
import NewPassword from "./newPwd";
import LoginForm from "./loginForm";
import ForgetPassword from "./forgetPassword";
import { useDynamicTab } from "../../component/useDynamicLogo";

const Login = () => {
  const [forgotPassword, setForgotPassword] = useState(false);
  const [showSendOtp, setShowSendOtp] = useState(false);
  const [showVerifyOtp, setShowVerifyOtp] = useState(false);
  const [resetPwd, setResetPwd] = useState(false);
  const [email, setEmail] = useState("");
  const [isOtpLogin, setIsOtpLogin] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const otpLogin = params.get("otpLogin");
    const redirectUrl = localStorage.getItem("redirectAfterLogin");
    // Only show OTP login if there's an actual paygroup value in the stored URL
    // Check for paygroup= followed by a non-empty value
    const hasValidPaygroup = redirectUrl && /paygroup=[^&]+/.test(redirectUrl);

    if (otpLogin === "true" || hasValidPaygroup) {
      setIsOtpLogin(true);
      setShowSendOtp(true);
      setForgotPassword(false);
      setShowVerifyOtp(false);
    } else {
      setIsOtpLogin(false);
      setShowSendOtp(false);
      setForgotPassword(false);
      setShowVerifyOtp(false);
    }
  }, []);

  const handleForgotPassword = () => {
    setForgotPassword(true); 
    setShowSendOtp(false); 
    setShowVerifyOtp(false)
  };

  const handleSendOTP = () => {
    setShowSendOtp(true);
    setForgotPassword(false);
    setShowVerifyOtp(false);
  };
  const handleVerifyOTP = () => {
    setShowVerifyOtp(true);
    setForgotPassword(false); 
    setShowSendOtp(false)
  };
    const handleEmailPassword = () => {
    setForgotPassword(false); 
    setShowSendOtp(false); 
    setShowVerifyOtp(false)
  };
  const handleReset = () => {setResetPwd(true)};
  useDynamicTab("Login");
  return (
    <Box
      sx={{
        height: "100vh",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#fff", // blue-purple bg
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 5,
          width: 380,
          borderRadius: 3,
          textAlign: "center",
          background: "#fff",
        }}
      >
        {/* Logo */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 3, // spacing below
          }}
        >
          {/* <AlliadLogo /> */}
        </Box>
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          {forgotPassword ? (
            <ForgetPassword handleEmailPassword={handleEmailPassword} setEmail={setEmail} email={email}  />
          ) : (
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
              {showSendOtp ? (
                <SendOtp  handleEmailPassword={handleEmailPassword} setEmail={setEmail} email={email} />
              ) : (
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                  {showVerifyOtp ? (
                    <VerifyOtp onVerifyOTP={handleVerifyOTP} />
                  ) : (
                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                      {resetPwd ? (
                        <NewPassword onReset={handleReset} />
                      ) : (
                        <LoginForm onForgetPwd={handleForgotPassword} handleSendOTP={handleSendOTP} setEmail={setEmail} email={email} />
                      )}
                    </Box>
                  )}
                </Box>
              )}
            </Box>
         )}
          </Box>
        {/* Footer */}
        <Typography
          variant="caption"
          sx={{ display: "block", mt: 4, color: "#888" }}
        >
          © {new Date().getFullYear()} cluBITS. All rights reserved.
        </Typography>
      </Paper>
    </Box>
  );
};

export default Login;
